// extracted by mini-css-extract-plugin
export default {"Container":"NoData_Container__8MYSL","HeadingText":"NoData_HeadingText__-+8HQ","SubText":"NoData_SubText__tX-8Y","Image":"NoData_Image__Ginag","OwnImage":"NoData_OwnImage__yBFcJ"};